CustomerAccountController.$inject = ["API_URL", "$http", "$q", "$timeout", "$rootScope", "$filter"];
angular.module('calendarApp').controller('CustomerAccountController', CustomerAccountController);

function CustomerAccountController(API_URL, $http, $q, $timeout, $rootScope, $filter) {
  var rego = this,
      throbber = $rootScope.throbber;
  rego.charging = smooth.charging;

  var init = function init() {
    throbber.show();
    $http.get(API_URL + '/api/v1/calendar/customer').then(function (_ref) {
      var response = _ref.data;
      throbber.hide();
      if (!response.success) return throbber.showError(response.msg);
      var customer = response.customer;
      rego.regoForm = angular.copy(smooth.forms.registration);
      rego.regoData = {};
      rego.form = {
        firstname: customer.firstname,
        lastname: customer.lastname,
        email: customer.email
      };

      if (response.customer.reginfo) {
        rego.regoData = response.customer.reginfo;
      }
    }).catch(function (err) {
      throbber.showError('Sorry but an error occurred: ' + err.message);
    });
  };

  init();

  rego.submitRego = function () {
    if (!rego.form.firstname || !rego.form.lastname || !rego.form.email) {
      alert('Please complete first name, last name and email fields');
      return;
    }

    rego.form.reginfo = rego.regoData || {};
    throbber && throbber.show();
    $http.put(API_URL + '/api/v1/calendar/customer', {
      customerinfo: rego.form
    }).then(function (_ref2) {
      var response = _ref2.data;
      if (!response.success) return throbber.showError('Sorry there was an error with this request: ' + response.msg);
      throbber.hide('Your details have been updated correctly');
    }).catch(function (err) {
      console.error(err.message);
      throbber.showError('Sorry but an error occurred with this request: ' + err.message);
    });
  };
}